import { render, staticRenderFns } from "./ImportEmploymentRefused.vue?vue&type=template&id=048beb0a"
import script from "./ImportEmploymentRefused.vue?vue&type=script&lang=js"
export * from "./ImportEmploymentRefused.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports